<style scoped>
  .hewly-build {font-size: 14px;color: #464c5b;font-weight: bold;height: 80px;line-height: 80px;border-bottom: 1px solid #d7dde4;}
  .com-btn {width: 100%;margin-bottom: 16px}
  .component >>> .close-icon {font-size: 20px;margin-left: 5px;color: red}
  .close{position: absolute;right: 0;background-color: red;width: 16px;height: 16px;border-radius: 8px;}
  .name{display: inline-block;font-size: 14px;color: #464c5b;margin-left: 4px;}
  .notice-background{background: url("/img/sys/bg11.png");height: 140px;}
  .mousedischarge{border-radius: 22px;height: 44px;border: 1px solid #d7dde4;display: inline-block;padding: 0 35px 0 5px;line-height: 44px;position: relative}
</style>

<template>
  <div style="background-color: #fff;" class="create">
    <Row>
      <Col span="24" class="notice-background"></Col>
    </Row>
    <Row style="text-align: center;">
      <Col span="24" class="hewly-build">
        新建审批名称：
        <Input style="width:200px;" v-model="name" placeholder="请输入审批模板名称"></Input>
      </Col>
    </Row>
    <Row style="padding:37px 0;width:100%">
      <Col span="14" class="component" style="padding:0 50px">
        <template v-for="(item,index) in approval">
          <component
              :contentIn="item.content"
              pattern="model"
			        style="margin:10px auto;"
              :index="index"
              :is="item.name"
              @change="item.content=$event"
              @del="approval.splice($event,1)"
          ></component>
        </template>
        <div v-if="approvalUserList.length>0">
          <div style="line-height:44px;width:100px;text-align: right;display: inline-block">审批人</div>
          ：
          <div style="display: inline-block;width:480px;vertical-align:top">
            <template v-for="(item,index) in approvalList">
              <div style="display: inline-block;margin-right: 15px;">
                <div class="mousedischarge">
                  <div class="close">
                    <Icon type="ios-close" @click="approvalList.splice(index,1)" color="white" size="20" style="position: absolute;top: -2px;left: -2px;"/>
                  </div>
                  <div v-if="getUserInfo(item)">
                    <Avatar :src="getUserInfo(item).icon" style="vertical-align: top;margin-top: 4px;"/>
                    <p class="name">{{getUserInfo(item).name}}</p>
                  </div>
                  <div v-else>
                    用户已失效
                  </div>
                </div>
              </div>
              <Icon style="margin-right:15px" type="md-arrow-forward" />
            </template>
            <userSelector
                :userList="approvalUserList"
                @inputChange="getAllUser($event).then((res)=>{approvalUserList = res})"
                @selected="approvalList.push($event.id);"
            >
              <template slot="title">
                <Icon type="md-add" color="#00a2e9" size="22" style="line-height: 44px"/>
              </template>
            </userSelector>
            <!--<Select size="large" @on-change="setApproverList" v-model="approverSelected" prefix="md-add" placeholder="请选择用户" style="width:120px">-->
              <!--<Option v-for="(item,index) in userList" :key="index" :value="item.id">-->
                <!--{{item.name}}-->
              <!--</Option>-->
            <!--</Select>-->
          </div>
          <div style="padding:10px"></div>
        </div>
        <div v-if="copyUserList.length>0">
          <div style="line-height:44px;width:100px;text-align: right;display: inline-block">抄送人</div>
          ：
          <div style="display: inline-block;width:480px;vertical-align:top">
          <template v-for="(item,index) in copyList">
            <div style="display: inline-block;margin-right: 15px;">
              <div class="mousedischarge">
                <div class="close">
                  <Icon type="ios-close" @click="copyList.splice(index,1)" color="white" size="20" style="position: absolute;top: -2px;left: -2px;"/>
                </div>
                <div v-if="getUserInfo(item)">
                  <Avatar :src="getUserInfo(item).icon" style="vertical-align: top;margin-top: 4px;"/>
                  <p class="name">{{getUserInfo(item).name}}</p>
                </div>
                <div v-else>
                  用户已失效
                </div>
              </div>
            </div>
            <Icon style="margin-right:15px" type="md-arrow-forward" />
          </template>
            <userSelector
                :userList="copyUserList"
                @inputChange="getAllUser($event).then((res)=>{copyUserList = res})"
                @selected="copyList.push($event.id);"
            >
              <template slot="title">
                <Icon type="md-add" color="#00a2e9" size="22" style="line-height: 44px"/>
              </template>
            </userSelector>
          <!--<Select size="large" @on-change="setCopyList" v-model="copySelected" prefix="md-add" placeholder="请选择用户" style="width:120px">-->
            <!--<Option v-for="(item,index) in userList" :key="index" :value="item.id">-->
              <!--{{item.name}}-->
            <!--</Option>-->
          <!--</Select>-->
          </div>
          <div style="padding:10px"></div>
        </div>
        &nbsp;
      </Col>
      <Col span="10">
        <Row :gutter="16" style="width:100%">
          <Col span="12">
            <Button icon="ios-add" @click="approval.push({name:'approvalInput',content:{}})" class="com-btn">
              输入框
            </Button>
          </Col>
          <Col span="12">
            <Button icon="ios-add" @click="approval.push({name:'approvalTextarea',content:{}})" class="com-btn">
              文本框
            </Button>
          </Col>
          <Col span="12">
            <Button icon="ios-add" @click="approval.push({name:'approvalRadio',content:{}})" class="com-btn">
              单项选择器
            </Button>
          </Col>
          <Col span="12">
            <Button icon="ios-add" @click="approval.push({name:'approvalCheckbox',content:{}})" class="com-btn">
              多项选择器
            </Button>
          </Col>
          <Col span="12">
            <Button icon="ios-add" @click="approval.push({name:'approvalDate',content:{}})" class="com-btn">
              日期选择器
            </Button>
          </Col>
          <!--<Col span="12">-->
          <!--<Button icon="ios-add" class="com-btn">-->
          <!--日期范围选择器-->
          <!--</Button>-->
          <!--</Col>-->
          <Col span="12">
            <Button icon="ios-add" @click="approval.push({name:'approvalTime',content:{}})" class="com-btn">
              时间选择器
            </Button>
          </Col>
          <!--<Col span="12">-->
          <!--<Button icon="ios-add" class="com-btn">-->
          <!--时间范围选择器-->
          <!--</Button>-->
          <!--</Col>-->
          <Col span="12">
            <Button icon="ios-add" @click="approval.push({name:'approvalFile',content:{}})" class="com-btn">
              签章文件上传
            </Button>
          </Col>
          <Col span="12">
            <Button icon="ios-add" @click="approval.push({name:'approvalFiles',content:{}})" class="com-btn">
              多文件/拍照上传
            </Button>
          </Col>
          <Col span="12">
            <Button icon="ios-add" @click="approval.push({name:'approvalExplain',content:{}})" class="com-btn">
              说明文字
            </Button>
          </Col>
        </Row>
      </Col>
    </Row>
    <Row>
      <Col span="24" style="text-align: center">
        <Button type="success" style="width:200px" @click="id?editApproval():createApproval()">保存模板</Button>
      </Col>
    </Row>
    <div style="padding:20px"></div>
  </div>
</template>

<script>
  import approvalCheckbox from '../../../components/setting/approval/approvalCheckbox'
  import approvalDate from '../../../components/setting/approval/approvalDate'
  import approvalDateRange from '../../../components/setting/approval/approvalDateRange'
  import approvalFile from '../../../components/setting/approval/approvalFile'
  import approvalFiles from '../../../components/setting/approval/approvalFiles'
  import approvalInput from '../../../components/setting/approval/approvalInput'
  import approvalRadio from '../../../components/setting/approval/approvalRadio'
  import approvalTextarea from '../../../components/setting/approval/approvalTextarea'
  import approvalTime from '../../../components/setting/approval/approvalTime'
  import approvalTimeRange from '../../../components/setting/approval/approvalTimeRange'
  import approvalExplain from '../../../components/setting/approval/approvalExplain'
  import userSelector from '../../../components/system/userSelector'

  export default {
    name: "create",
    data() {
      return {
        approvalSelected:'',
        copySelected:'',
        copyUserList:[],
        approvalUserList:[],
        userList:[],
        approval: [],
        name: '',
        copyList: [],//抄送人员列表
        approvalList: [],//审批人员列表
        id:'',
      }
    },
    components: {
      approvalCheckbox: approvalCheckbox,
      approvalDate: approvalDate,
      approvalDateRange: approvalDateRange,
      approvalFile: approvalFile,
      approvalFiles: approvalFiles,
      approvalInput: approvalInput,
      approvalRadio: approvalRadio,
      approvalTextarea: approvalTextarea,
      approvalTime: approvalTime,
      approvalTimeRange: approvalTimeRange,
      approvalExplain: approvalExplain,
      userSelector:userSelector,
    },
    methods: {
      getUserList: function () {
        this.getAllUser().then((res)=>{
          this.approvalUserList = res
          this.copyUserList = res
          this.userList = res
          if(this.$route.params.approval){
            console.log(this.$route.params.approval)
            this.name = this.$route.params.approval.name
            this.approvalList = this.$route.params.approval.approvalList||[]
            this.copyList = this.$route.params.approval.copyList||[]
            this.approval = this.$route.params.approval.data
            this.id = this.$route.params.approval.id
          }
        })
      },
      getUserInfo:function(val){
        for(var i=0;i<this.userList.length;i++){
          if(this.userList[i].id==val){
            return this.userList[i]
          }
        }
      },
      editApproval:function(){
        var _this = this
        _this.send({
          headers: 'L/EditApprovalMode',
          data:{
            ApprovalModeId:_this.id,
            ApprovalModeContent: _this.approval,
            ApprovalAssessorId: _this.approvalList.toString(),//审批人
            ApprovalCopyId: _this.copyList.toString(),//抄送人
            ApprovalModeTitle: _this.name,//审批标题
            ApprovalTypeId: _this.$route.query.typeId,//所属类型
          },
          success:function () {
            _this.$Notice.success({
              title:'系统消息',
              desc:'保存成功！'
            })
            _this.$router.push({name:'approvalList',query:{typeId:_this.$route.query.typeId}})
          }
        })
      },
      createApproval: function () {
        var _this = this
        _this.send({
          headers: 'L/AddApprovalMode',
          data: {
            ApprovalModeContent: _this.approval,
            ApprovalAssessorId: _this.approvalList.toString(),//审批人
            ApprovalCopyId: _this.copyList.toString(),//抄送人
            ApprovalModeTitle: _this.name,//审批标题
            ApprovalTypeId: _this.$route.query.typeId,//所属类型
          },
          success: function () {
            _this.$Notice.success({
              title:'系统消息',
              desc:'保存成功！'
            })
            _this.$router.push({name:'approvalList',query:{typeId:_this.$route.query.typeId}})
          }
        })
      }
    },
    mounted: function () {
      this.getUserList()
    }
  }
</script>

